import React, { ReactNode } from "react";
import { Offcanvas } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Define props interface for the component
interface OverlayDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  placement?: "start" | "end" | "top" | "bottom";
  title: string;
  width?: string;
  height?: string;
  top?: string;
}

const InvoiceCommentsDrawer: React.FC<OverlayDrawerProps> = ({
  open,
  onClose,
  children,
  placement = "end",
  title,
  width = "60%",
  height = "auto",
  top = "125px",
}) => {
  return (
    <Offcanvas
      show={open}
      onHide={onClose}
      placement={placement}
      backdrop="static"
      keyboard={false}
      style={{
        width: placement === "end" || placement === "start" ? width : "100%",
        height,
        top,
        bottom: "25px",
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
        <button
          id="log-overlay-drawer"
          className="btn btn-link"
          style={{
            position: "absolute",
            top: "6px",
            right: "10px",
            fontSize: "16px",
            border: "none",
            background: "none",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <span className="material-icons theme-color">close</span>
        </button>
      </Offcanvas.Header>

      <Offcanvas.Body style={{ overflowY: "auto" }}>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default InvoiceCommentsDrawer;
